module.exports = __webpack_public_path__ + "static/media/skills.0c11bb02.svg";